import { Button } from 'antd';
import React, { Component } from 'react';
import { AdminLayout, ClassicLayout } from '../Layout';
import logo from './../../assets/images/logo.svg';
import './app.css';
import '../../assets/styles/react-transitions.css';
import { BrowserRouter, Switch, Route, Router } from 'react-router-dom';
import MainContent, { RoutesRenderer } from '../Layout/MainContent';
import AuthContextProvider from '../UserManagement/AuthContextProvider';
import './ant-design-overrides.less';
import './style-override.less';
import * as H from 'history';

import ErrorMonitor from '../ErrorMonitor';
import Feedback from '../Feedback';
import CartContextProvider from 'components/CartManagement/CartContextProvider/CartContextProvider';
import LogRocketErrorMonitor from 'components/LogRocketErrorMonitor';
import NavigationEventMonitor from 'components/NavigationEventMonitor';
import GeneralNotificationView from 'components/Payment/GeneralNotificationView';
import { Helmet } from 'react-helmet';
import SmartlookErrorMonitor from 'components/SmartlookErrorMonitor';

const myHistory = H.createBrowserHistory();
class App extends Component {
  public render() {
    return (
      <div className="App">
        <Helmet titleTemplate="%s - KWL BOL Pay" defaultTitle="KWL BOL Pay" />
        <Feedback>
          <ErrorMonitor>
            <LogRocketErrorMonitor>
              <SmartlookErrorMonitor>
                <Router history={myHistory}>
                  <AuthContextProvider>
                    <GeneralNotificationView>
                      <NavigationEventMonitor>
                        <CartContextProvider>
                          <div className="transition-container">
                            <Switch>
                              <RoutesRenderer defaultLayout={AdminLayout} />
                            </Switch>
                          </div>
                        </CartContextProvider>
                      </NavigationEventMonitor>
                    </GeneralNotificationView>
                  </AuthContextProvider>
                </Router>
              </SmartlookErrorMonitor>
            </LogRocketErrorMonitor>
          </ErrorMonitor>
        </Feedback>
      </div>
    );
  }
}

export default App;
